export default __webpack_public_path__ + "static/media/mailHover.bbb443b3.svg";